export default {
  tag: {
    type: String,
    default: 'div',
  },
}



// WEBPACK FOOTER //
// ./src/js/util/props/tag.js